import { render, staticRenderFns } from "./editStorechannel.vue?vue&type=template&id=b1f7a6b8&scoped=true"
import script from "./editStorechannel.vue?vue&type=script&lang=js"
export * from "./editStorechannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7a6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f7a6b8')) {
      api.createRecord('b1f7a6b8', component.options)
    } else {
      api.reload('b1f7a6b8', component.options)
    }
    module.hot.accept("./editStorechannel.vue?vue&type=template&id=b1f7a6b8&scoped=true", function () {
      api.rerender('b1f7a6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/shoplist/editStorechannel.vue"
export default component.exports